import React from 'react';
import './feature.css';

const Feature = ({ title, text }) => (
  <div className="fgc__features-container__feature">
    <div className="fgc__features-container__feature-title gradient__text">
      <h1>{title}</h1>
    </div>
    <div className="fgc__features-container_feature-text">
      <p>{text}</p>
    </div>
  </div>
);

export default Feature;
